module.exports = __webpack_public_path__ + "static/media/printing-services-img12.5c09eb29.jpg";